import { Button, Icon, Input } from "@elaniintc/goes-design-system";

export interface InputCounterProps {
  label: string;
  value: number;
  max: number;
  min: number;
  disabled?: boolean;
  onChange: (value: number) => void;
}

export const InputCounter = ({
  label,
  value: currentValue,
  max,
  min = 0,
  disabled,
  onChange,
}: InputCounterProps) => {
  const handleIncrement = () => {
    onChange(currentValue + 1);
  };

  const handleDecrement = () => {
    onChange(currentValue - 1);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    // If input is empty, set to 0
    if (inputValue === "") {
      onChange(0);
      return;
    }

    const value = Number.parseInt(inputValue, 10);
    if (!Number.isNaN(value)) {
      const clampedValue = Math.max(min, Math.min(max, value));
      onChange(clampedValue);
    }
  };

  return (
    <div className="flex flex-col md:flex-row items-center gap-1">
      <label className="text-body text-sm font-normal leading-3xl">
        {label}
      </label>
      <div className="flex">
        <Button
          disabled={disabled || currentValue <= min}
          variant="tertiary"
          size="xs"
          className="w-8 h-8"
          group="left"
          onClick={handleDecrement}
          type="button"
        >
          <Icon type="fas" name="minus" size="xs"></Icon>
        </Button>
        <Input
          disabled={disabled}
          type="text"
          className="text-center w-10 h-8 px-2 py-1 text-sm leading-2xl"
          group="middle-up"
          value={currentValue}
          onChange={handleInputChange}
        />
        <Button
          disabled={disabled || currentValue >= max}
          variant="tertiary"
          size="xs"
          className="w-8 h-8"
          group="right"
          onClick={handleIncrement}
          type="button"
        >
          <Icon type="fas" name="plus" size="xs"></Icon>
        </Button>
      </div>
    </div>
  );
};
